// removed by extract-text-webpack-plugin
module.exports = {"page-heading":"page-heading__3xYl6","page-sub-heading":"page-sub-heading__2odU6","accrodion-subtitle":"accrodion-subtitle__c8Rii","heading":"heading__2xW8m","sub-heading":"sub-heading__2I--1","arrow-container":"arrow-container__1kqTV","download-link":"download-link__2vhDP","verify-block":"verify-block__UBHD5","documents-list":"documents-list__1NM6g","verify-btn":"verify-btn__2cfw2","highlight":"highlight__1lpQv","taste-box":"taste-box__33t7x","empty":"empty__2zBrD","kyc_doc_errors":"kyc_doc_errors__Rs1pl"};


//////////////////
// WEBPACK FOOTER
// ./styles/kyc.scss
// module id = 1202
// module chunks = 68